<template>
  <div class="order-list tt-custom-tab article" style="padding:24px 32px 0;">
    <div style="display:flex;justify-content: center;padding-bottom:16px;border-bottom:1px solid #f4f4f4;">
      <div class="article-tabName" :class="{'selected':form.type==tab.value}" v-for="(tab,index) in tabs" @click="changeArticleType(tab.value)">
        {{ tab.name }}
      </div>
    </div>
    
    <template v-if="form.type!=4">
      <div v-if="totalCount" class="table" ref="scrollContainer" :style="{'height':tableHeight+'px'}" v-infinite-scroll="search" :infinite-scroll-distance="10">     
          <div v-for="(list,w_index) in waterfallList" :key="w_index" style="width:210px;">
            <a v-for="(r,index) in list" :key="index" class="article_card" :href="`/explore/post?id=${r.post_id}`" @click.prevent="openArticleDetail(r)">
              <div style="position: relative;">
                <img @error="handleImageError" referrerpolicy="no-referrer" :src="r.media_list[0].url" class="article_card_img"/>
                <div v-if="r.account_id==account_id" style="position: absolute;left:6px;bottom:6px;border-radius: 3px;background: rgba(0, 0, 0, 0.5);color: white;padding: 3px 5px;">
                    <i class="el-icon-view" style="font-size: 16px;position: relative;top:1px;"></i> <label style="position:relative;top:0.5px;">{{ r.views_count }}</label>
                </div>
              </div>
              <div style="padding:12px;">
                <div style="margin-bottom:8px;color:#333;font-size: 14px;line-height: 140%;">{{ r.title }}</div>
                <div style="display:flex;justify-content: space-between;align-items: center;">
                  <div style="display: flex;align-items: center;">
                    <template v-if="r.type!='0'">
                      <img class="flag" v-if="r.merchant_info && r.merchant_info.country" :src="`https://pic.joyorders.com/country/${r.merchant_info.country.toLowerCase()}.png`" />
                      <img v-else src="../../assets/images/offlinePic.png" style="width:20px;height:20px;border-radius:10px;margin-right:6px;object-fit: contain;"/>
                    </template>
                    <template v-else>
                      <template v-if="r.account_profile">
                        <img :src="r.account_profile" style="width:20px;height:20px;border-radius:10px;margin-right:6px;"/>
                      </template>
                      <template v-else>
                        <img src="../../assets/images/avatar@2x.png" style="width:20px;height:20px;border-radius:10px;margin-right:6px;"/>
                      </template>
                    </template>
                    <template v-if="r.type!='0'">
                      <label style="font-size:12px;color:rgba(51, 51, 51, 0.8);">{{ r.merchant_info && (r.merchant_info.name || r.merchant_info.name_en)?(r.merchant_info.name || r.merchant_info.name_en):'未知商家' }}</label>
                    </template>
                    <template v-else>
                      <label style="font-size:12px;color:rgba(51, 51, 51, 0.8);">{{ (r.account_nickname || r.account_name) }}</label>
                    </template>
                  </div>
                  <div style="display:flex;align-items: center;">
                    <!--<img class="agree-icon" v-if="r.liked==1" src="../../assets/images/agree-full.png" @click.stop.prevent="toggleLike(r)"/>
                    <img class="agree-icon" v-else src="../../assets/images/agree.png" @click.stop.prevent="toggleLike(r)"/>-->
                    <img class="view-icon" src="../../assets/images/view.png"/>
                    <label style="color:rgba(51, 51, 51, 0.8);;font-size: 12px;">{{ r.views_count }}</label>
                  </div>
                </div>
              </div>
              <!--<div>
                <p style="font-size:20px;">{{ r.title }}</p>
                <p style="font-size:12px;color:#aaa;margin:10px 0;">{{ generateDateDisplay(r.create_time) }}</p>
                <p v-html="r.content"></p>
              </div>-->
            </a>
          </div>
      </div>
    </template>
    <template v-else>
        <div v-if="totalCount>0" :style="{'height':(tableHeight-4)+'px'}">
          <div style="margin:20px 0 20px;">
            <el-autocomplete class="height40_auto"
                style="width: 240px; height:40px;"
                v-model="relationMerchant"
                :fetch-suggestions="querySearch"
                @select="handleAutoSelect"
                @input="handleAutoChange"
                placeholder="商家"
              ></el-autocomplete>
          </div>
          <PRODUCTLIST @startloading="loading=true" @finishloading="loading=false" @total_fav="handleTotal" noNeedSelect="1" :merchant_id="merchant_id" isCollection="1" :tableHeight="(tableHeight-80)+'px'"></PRODUCTLIST>
        </div>
      </template>
    <div v-if="totalCount === 0 && !loading" :style="{'height':tableHeight+'px'}" class="emptyContent">
      <p>{{ emptytext }}</p>
    </div>
    <div style="position: fixed;bottom:30px;right:60px;">
      <div class="waterfallbutton" style="margin-bottom:10px;">
        <i class="el-icon-top" style="font-size:20px;" @click.stop="toTop"></i>
      </div>
      <div class="waterfallbutton">
        <i class="el-icon-refresh" style="font-size:20px;" @click.stop="search(true)"></i>
      </div>
    </div>
    <!--<div class="yd-pagination" v-if="totalCount / form.limit > 1">
      <el-pagination :page-size="form.limit" :pager-count="5" :current-page.sync="form.page" layout="prev, pager, next"
        next-text="下一页" prev-text="上一页" :total="totalCount" @current-change="search">
      </el-pagination>
    </div>-->

    <el-dialog v-if="articleDetailVisible" top="0" class="el-dialog-sm custom-width-dialog-900 no-padding" :show-close="false" :visible.sync="articleDetailVisible" width="90%">
      <ARTICLE :articleId="cur_articleId"></ARTICLE>
    </el-dialog>
  </div>
</template>

<script>
//import Mail from './MailBody.vue'
import api from '../../services/api.js'
import { API_HOST } from '../../services/constant.js'
import ARTICLE from '../../components/ArticleDetail'
import PRODUCTLIST from '../../components/ProductList'

let _ = require('lodash')

export default {
  name: 'OrderList',
  data() {
    return {
      relationMerchant:'',
      merchant_id:'',
      listmethods:'getMyArticleList',
      countmethods:'getMyArticleCount',
      emptytext:'你还没有发布任何内容哦',
      loading:true,
      articleDetailVisible:false,
      cur_articleId:'',
      tabs:[{name:'笔记',value:'1'},{name:'收藏',value:'2'},{name:'点赞',value:'3'},{name:'商品收藏',value:'4'}],
      API_HOST:API_HOST,
      account_id:this.$localStorage.get('account_id'),
      articleList: [],
      waterfallList:[],
      form:{
        limit:10,
        page:0,
        type:'1'
      },
      tableHeight:0,
      columnCount:5,
      totalCount:0,
      headers:{},
      editorOptions: {
        theme: 'snow', 
        modules: {
          toolbar: false
        },
        placeholder: '请输入内容...'
      }
    }
  },
  computed: {
      searchWord() {
        return this.$store.state.articleKeyword
      },
  },
  watch:{
    searchWord(){
      this.search(true)
    }
  },
  components:{
    ARTICLE,PRODUCTLIST
  },
  created () {
    this.headers.token = this.$localStorage.get('token')
  },
  mounted() {
    const viewportWidth = window.innerWidth;
    if(viewportWidth>=1200)
      this.columnCount=5;
    else if(viewportWidth>=960)
      this.columnCount=4;
    else if(viewportWidth>=720)
      this.columnCount=3;
    else
      this.columnCount=2;
    this.tableHeight=window.innerHeight-145-24-16-56;
    this.search(true)
  },
  methods: {
    handleTotal(data){
      this.totalCount=data;
    },
    handleAutoChange(value){
      if(!value){
        this.merchant_id=''       
      }
    },
    handleAutoSelect(item){
      this.merchant_id = item.id;
    },
    async querySearch(queryString, cb){
      let query = {
        keyword: queryString
      }
      let res = await api.searchBusiness(this,query)
      let arr = []
      res.body.result.forEach(item => {
        arr.push({value:item.name,id:item.id,tag:item.tag,country:item.country})
      })
      cb(arr)
    },
    changeArticleType(type){
      this.form.type=type;
      switch(this.form.type){
        case '1':
          this.listmethods='getMyArticleList';
          this.countmethods='getMyArticleCount';
          this.emptytext='你还没有发布任何内容哦';
          break;
        case '2':
          this.listmethods='getMyCollArticleList';
          this.countmethods='getMyCollArticleCount';
          this.emptytext='你还没有收藏任何内容哦';
          break;
        case '3':
          this.listmethods='getMyLikeArticleList';
          this.countmethods='getMyLikeArticleCount';
          this.emptytext='你还没有赞过任何内容哦';
          break;
        case '4':
          this.emptytext='你还没有收藏任何商品哦';
          break;
      }
      this.search(true);
    },
    async toggleLike(c){
      let url = '';
      let id = c.post_id;
        if(c.liked==1){
          url = 'cancel_like';
          c.liked=0
        }
        else{
          url = 'like';
          c.liked=1;
        }
      let res = await api.post(this, {
        path: 'cm.php',
        api: url,
        data: {
          target_type:'post',
          target_id:id
        }
      })
      res = res.body
      if (res.status == 'ok') {
        let t = +c.likes_count;
        if(c.liked==1){
          c.likes_count=t+1;
        }
        else{
          c.likes_count=t-1;
        }
      } 
    },
    toTop(){
      this.$refs.scrollContainer.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },
    handleImageError(e){
      e.target.src=require('@/assets/images/joyLogoL.png');
      e.target.onerror = null;
    },
    openArticleDetail(r){
      if(r.status=='0'){
        this.$router.push({path: '/publish?edit='+r.post_id})
      }
      else{
        this.cur_articleId=r.post_id;
        this.articleDetailVisible=true;
      }
    },
    search(needReload){
      const generateParams=(needReload)=>{
        let params={}
        params.limit=this.form.limit;
        if(needReload)
          this.form.page=1
        else
          this.form.page++;
        params.page=this.form.page;
        if(this.searchWord.trim()!='')
          params.keyword=this.searchWord
        /*for(let p in this.form){
          if(this.form[p])
            params[p]=this.form[p]
        }
        if(this.timeRange.length){
          params.start_time=this.$moment(this.timeRange[0]).format('YYYY-MM-DD HH:mm')
          params.end_time=this.$moment(this.timeRange[1]).format('YYYY-MM-DD HH:mm')
        }
        if(this.searchWord){
          switch(this.keyword_type){
            case '1':
              params.merchant_order_number=this.searchWord;
              break;
            case '2':
              params.tracking_number=this.searchWord;
              break;
            case '3':
              params.gift_card_number=this.searchWord;
              break;
          }
        }*/
        return params
      }
      let params=generateParams(needReload)
      if(needReload)
        this.getListCount(params);
      else
        this.getList(params,needReload);
    },
    generateDateDisplay(datestring){
      let today=new Date()
      let yesterday=new Date(today.getTime() -24*60*60*1000)
      let today_string=this.$moment(today).format('YYYY-MM-DD')
      let yest_string=this.$moment(yesterday).format('YYYY-MM-DD')
      if(datestring==today_string)
        return '今天';
      if(datestring==yest_string)
        return '昨天';
      return datestring
    },
    getList(params,needReload) {
      this.loading=true;
      api[this.listmethods](this, params).then((res) => {
        this.loading=false;
        this.articleList = res.body.result;
        //let columnindex_arr = [];
        if(needReload){
          this.$refs.scrollContainer.scrollTo({
            top: 0,
            behavior: 'smooth'
          });
          this.waterfallList=[]
          for(var i=0;i<this.columnCount;i++){
            //columnindex_arr.push(i);
            this.waterfallList.push([]);
          }
        }
        this.articleList.forEach((i,index)=>{
          let yy = index%this.columnCount;
          console.log('water',this.waterfallList);
          this.waterfallList[yy].push(i);
        })
      })
    },
    getListCount(params){
      this.totalCount=0;
      let p = JSON.parse(JSON.stringify(params))
      delete params.page
      delete params.limit
      api[this.countmethods](this,params).then((res)=>{
        this.totalCount=+res.body.result;
        this.getList(p,true);
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .flag {
    width: 20px;
    height: 14px;
    margin-right:3px;
    object-fit: contain;
  }
  .emptyContent{
    width:100%;
    text-align: center;
    padding-top:10%;
    color:rgba(51,51,51,0.6)
  }
  .article-tabName{
    color:#666;
    font-size: 16px;
    height:40px;
    line-height: 40px;
    padding:0 16px;
    cursor: pointer;
  }
  .article-tabName.selected{
    background:rgba(0,0,0,0.03);   
    font-weight: bold;
    color:#333;
    border-radius: 3px;
  }
  .waterfallbutton{
    cursor: pointer;
    background: white;
    box-shadow:0 2px 8px 0 rgba(0,0,0,.05),4px 4px 2px 0 rgba(0,0,0,.3);
    border-radius: 20px;
    width:40px;
    height:40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .article_card{
    width:210px;
    margin-bottom:10px;
    padding-bottom:10px;
    cursor: pointer;
    display:inline-block;
    color:#333;
  }
  .article_card_img{
    width:100%;
    max-height: 283px;
    object-fit: cover;
    border-radius: 3px;
    border:1px solid rgba(0,0,0,.08);
  }
.empty-content {
  padding: 50px 0 50px;
}
.table{
  position: relative;
  margin-top:16px;
  display:flex;
  overflow: auto;
  justify-content: space-between;
}
.table::-webkit-scrollbar {
  display: none;
}
.order-list{
  margin-bottom: 0 !important;
}
</style>

<style lang="scss">
.order-list {
  .el-tabs__content {
    overflow: visible;
  }
}

.search-bar {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  margin-bottom:10px;
  &.seprator{
    justify-content: space-between;
  }
}
.yd-pagination{
  margin-top:30px;
}

@font-face {
  font-family: "iconfont"; /* Project id 2668685 */
  src: 
       url('../../assets/iconfont/iconfont.woff2?t=1626081681400') format('woff2'),
       url('../../assets/iconfont/iconfont.woff?t=1626081681400') format('woff'),
       url('../../assets/iconfont/iconfont.ttf?t=1626081681400') format('truetype');
}

.iconfont {
  font-family: "iconfont" !important;
  font-size: 16px;
  font-style: normal;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

.el-icon-joyorderagree:before {
  content: "\e61d";
}
</style>



// WEBPACK FOOTER //
// src/pages/articles/Mypost.vue